module.exports = __webpack_public_path__ + "static/img/p_03.e421d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_03.png
// module id = 757
// module chunks = 1